import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        “We have many regular suppliers, and often we get advance notice, but sometimes there are
        nice surprises where a truck arrives and drops off various pallets of food,” says Lucy
        Danger, chief executive of{' '}
        <a
          href="https://www.emerge3rs.co.uk/"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          EMERGE 3Rs,
        </a>{' '}
        the charitable organization that operates the Greater Manchester branch of FareShare.
        FareShare is the UK’s longest-running food redistribution charity. Its mission is all about
        making sure that good food doesn’t go to waste, but rather gets shared with the people who
        need it most.
      </p>
      <p className="chapter__paragraph">
        “There are literally thousands of people across Greater Manchester who struggle to put a
        proper meal on the table,” Danger says. “So, there’s a real sense of urgency about how
        quickly we can process the changing flow of donations.”
      </p>
      <p className="chapter__paragraph">
        FareShare Greater Manchester (GM) has forged a partnership with a technology company called{' '}
        <a
          href="https://peak.ai/"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          Peak
        </a>
        . Also based in Manchester, Peak specializes in Decision Intelligence, which means the
        company uses its cloud-based platform built on Amazon Web Services (AWS) with Intel
        technology to help customers apply artificial intelligence (AI) to their decision-making
        processes. FareShare is working with Peak to use this intelligence to match supply and
        demand and increase the efficiency of food redistribution.
      </p>
    </section>
  );
}

export default Chapter2;
